<template>
  <!--右侧树形展示所有停车场，岗位，停车位-->

  <div class="trees gatewayTree">
    <!-- <el-scrollbar style="height:100%"> -->
    <el-input class="search" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
    <el-tree
      ref="tree"
      :data="allDatas"
      :props="defaultProps"
      @node-click="handleTreeClick"
      node-key="id"
      :highlight-current="true"
      :show-checkbox="false"
      :default-expanded-keys="nodeKeys"
      :filter-node-method="filterNode"
    >
      <span slot-scope="{data}">
        <span v-if="data.type=='admin'">{{data.name}}</span>
        <span v-if="data.type=='group'">
          <span class="group-name-tip">集团</span>
          {{data.name}}
        </span>
        <span v-if="data.type=='property'">
          <span class="group-name-tip">物业</span>
          {{data.name}}
        </span>
        <span v-if="data.type=='parking'">
          <span class="group-name-tip">道路</span>
          {{data.name}}
        </span>
        <span v-if="data.type=='station'">
          <span class="group-name-tip">网关</span>
          {{data.name}}
        </span>
      </span>
    </el-tree>
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
import { gatewayTree } from "@/api/url";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      allDatas: [],
      nodeKeys: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      filterText: "",
    };
  },
  props: {
    moduleName: String,
    areaId: String,
  },
  methods: {
    ...mapMutations(["setNodeData", "setNod", "getPage"]),
    //获取所有的停车场，岗位，停车位用于右侧树形展示
    getAllDatas: function () {
      var _this = this;
      this.$get(gatewayTree()).then((data) => {
        // if(data.status!=200) return;
        this.allDatas = data;
        var type = data[0].type;
        if (this.moduleName == "station") {
          let tempArray = new Array();
          let temp = this.getDataByType("parking", data[0]);
          tempArray[0] = temp;
          this.allDatas = tempArray;
        } else {
          this.allDatas = data;
        }
        this.allDatas.forEach(function (item) {
          _this.nodeKeys.push(item.id);
        });
      });
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.setNodeData(node);
      this.setNod(data);
      this.getPage({
        curIndex: 1,
        rowsCount: 0,
      });
      this.$emit("handleTreeClick", node, data);
    },
    setCurrent(id) {
      this.$refs.tree.setCurrentKey(id);
    },

    getDataByType(type, data) {
      if (!data) {
        return;
      }
      if (data.type != type) {
        if (!Array.isArray(data.children)) {
          return data;
        } else {
          const children = data.children
            .map((ele) => {
              // console.log("ele")
              // console.log(ele)
              return this.getDataByType(type, ele);
            })
            .filter((ele) => ele !== null);
          return {
            type: data.type,
            name: data.name,
            id: data.id,
            children,
          };
        }
      } else {
        return {
          type: data.type,
          name: data.name,
          id: data.id,
        };
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  created() {
    this.getAllDatas();
  },
  mounted() {},
  computed: {
    //根据获取的所有车位信息计算出树形结构需要的信息
    getAllSpace: function () {
      var jsTreeDatas = [];
      var d = this.allDatas;
      if (this.moduleName != "space") {
        this.fn(d, jsTreeDatas);
      } else {
        return this.allDatas;
      }
    },
    //根据获取的所有车位信息计算出树形结构需要的信息
    getAllSpace1: function () {
      // console.log('789')
      if (this.allDatas.length != 0) {
        var jsTreeDatas = [];
        var itemZero = {
          onlyId: "",
          id: "001",
          label: "全部",
          level: "0",
          children: [],
        };
        var allDatas = this.allDatas;
        for (let index1 in allDatas) {
          //一级目录parking
          let itemOne = {
            onlyId: "",
            id: "", //parkingId
            label: "",
            level: "1",
            className: "parkClass",
            children: [],
          };
          itemOne.onlyId = "1_" + index1;
          itemOne.id = allDatas[index1].parkingId;
          itemOne.label = allDatas[index1].parkingName;

          //读取岗位
          if (
            allDatas[index1].arealist != "" &&
            allDatas[index1].arealist != undefined &&
            this.moduleName == ""
          ) {
            var area = allDatas[index1].arealist;
            // console.log(area)
            for (let index2 in area) {
              //二级目录岗位area
              let itemTwo = {
                onlyId: "",
                id: "", //areaId
                label: "",
                level: "2",
                className: "areaClass",
                children: [],
              };
              itemTwo.onlyId = "2_" + index2;
              itemTwo.id = area[index2].areaId;
              itemTwo.label = area[index2].areaName;
              itemOne.children.push(itemTwo);

              //读取车位
              /*if(area[index2].attr1!=""&&area[index2].attr1!=undefined){
						var space=JSON.parse(area[index2].attr1);
					
					for(let index3 in space){			
					//三级目录岗位space
					let itemThree={
						onlyId:'',
						id:"",//spaceId
						label:"",
						level:"3",
						className:"spaceClass",
						children:[]
					};
					itemThree.onlyId="3_"+index3;
					
					itemThree.id=space[index3].spaceId;
					itemThree.label=space[index3].spaceNum;
					
					itemTwo.children.push(itemThree);
					}
					}*/
            }
          }
          itemZero.children.push(itemOne);
        }
        //console.log("jsTreeDatas")
        //console.log(jsTreeDatas)
        jsTreeDatas.push(itemZero);
        // console.log(jsTreeDatas)
        return jsTreeDatas;
      }
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {},
      // 深度观察监听
      deep: true,
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped>
/* @import "@/assets/css/areaTree.css"; */
.el-tree {
  color: #5c5c5c !important;
  overflow: auto;
  height: calc(100vh - 160px);
  width: 100%;
}

.is-current {
  background: #afc0e9 !important;
}
.trees {
  border-right: 10px solid #eff2f7;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #ccc !important;
}

.isActive {
  background: #ccc !important;
}
.group-name-tip {
  color: red;
  font-size: 10px;
}
.search {
  border-radius: 10px !important;
  margin-bottom: 10px;
}
.parkClass {
  display: inline-block;

  height: 15px;
  line-height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/park.png") no-repeat left center;
  padding-left: 20px;
  /*font-weight: bold;*/
  color: #606266;
  font-size: 14px;
}
.areaClass {
  display: inline-block;
  line-height: 15px;
  height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/area.png") no-repeat left center;
  padding-left: 20px;
}
.spaceClass {
  display: inline-block;
  width: 10px;
  height: 10px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/space.png") no-repeat center center;
}

.trees {
  border-right: 10px solid #eff2f7;
  padding: 10px 5px 0 5px;
  box-sizing: border-box;
  height: 100%;
}
</style>
<style>
</style>